<template>
  <section class="contact-section position-relative see__pad">
    <!-- Multiple Pattern Layers -->
    <div class="pattern-layer">
      <div class="pattern-1 position-absolute" style="background-image: url('/shapes/shape-06.png')"></div>
    </div>
    <div class="pattern-layer">
      <div class="pattern-2 position-absolute" style="background-image: url('/shapes/shape-08.png')"></div>
    </div>
    
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <div class="contact-header text-center">
            <div class="contact-section-label">
              <h4>{{ content.sectionLabel }}</h4>
            </div>
            <div class="contact-main-title">
              <h2>{{ content.mainTitle }} <span>{{ content.mainTitleHighlight }}</span></h2>
            </div>
            <div class="contact-description">
              <p>{{ content.description }}</p>
            </div>
          </div>
        </div>
      </div>
      
      <div class="row">
        <div 
          v-for="(contact, index) in content.contactMethods" 
          :key="index"
          class="col-lg-4 col-md-6"
        >
          <div class="contact-info-card">
            <div class="contact-icon">
              <i :class="contact.icon"></i>
            </div>
            <div class="contact-details">
              <h4>{{ contact.title }}</h4>
              <p v-html="contact.details"></p>
              <span>{{ contact.subtitle }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "HomeItsContactComp",
  props: {
    content: {
      type: Object,
      required: true,
      default: () => ({
        sectionLabel: "Get In Touch",
        mainTitle: "Ready to Start Your",
        mainTitleHighlight: "Digital Journey",
        description: "Connect with our team of experts and let's discuss how we can help transform your ideas into reality with cutting-edge technology and innovative solutions.",
        contactMethods: [
          {
            icon: "icon-03",
            title: "Email Us",
            details: "info@sogdo.com",
            subtitle: "We'll respond within 24 hours"
          },
          {
            icon: "icon-04",
            title: "Call Us",
            details: "+1 (555) 123-4567",
            subtitle: "Mon-Fri, 9AM-6PM EST"
          },
          {
            icon: "icon-05",
            title: "Visit Us",
            details: "123 Tech Street<br>Innovation District",
            subtitle: "Available for meetings"
          }
        ]
      })
    }
  }
}
</script>

<style scoped>
/* Contact Section Styles */
.contact-section {
  padding: 100px 0;
  background: #00061A;
  position: relative;
  overflow: hidden;
}

.contact-section .pattern-layer {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
}

.contact-section .pattern-1 {
  top: 15%;
  right: 8%;
  width: 120px;
  height: 120px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  opacity: 0.1;
}

.contact-section .pattern-2 {
  bottom: 20%;
  left: 5%;
  width: 100px;
  height: 100px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  opacity: 0.08;
}

.contact-header {
  position: relative;
  z-index: 2;
  margin-bottom: 60px;
}

.contact-section-label h4 {
  font-size: 20px;
  font-weight: 400;
  letter-spacing: 13.2px;
  color: #F6EC4F;
  margin-bottom: 20px;
  font-family: 'Archivo', sans-serif;
  text-transform: uppercase;
}

.contact-main-title h2 {
  font-size: 48px;
  font-weight: 700;
  line-height: 58px;
  color: #fff;
  margin-bottom: 30px;
  font-family: 'Archivo', sans-serif;
}

.contact-main-title h2 span {
  color: #F6EC4F;
}

.contact-description p {
  font-size: 18px;
  line-height: 28px;
  color: #fff;
  margin-bottom: 0;
  font-family: 'Open Sans', sans-serif;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
}

/* Contact Info Cards */
.contact-info-card {
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(246, 236, 79, 0.1);
  border-radius: 15px;
  padding: 30px 25px;
  text-align: center;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
  height: 100%;
  margin-bottom: 30px;
}

.contact-info-card:hover {
  transform: translateY(-5px);
  border-color: #F6EC4F;
  box-shadow: 0 15px 30px rgba(246, 236, 79, 0.15);
}

.contact-icon {
  margin-bottom: 20px;
}

.contact-icon i {
  font-size: 40px;
  color: #F6EC4F;
  display: inline-block;
  width: 60px;
  height: 60px;
  line-height: 60px;
  background: rgba(246, 236, 79, 0.1);
  border-radius: 50%;
  transition: all 0.3s ease;
}

.contact-info-card:hover .contact-icon i {
  background: #F6EC4F;
  color: #00061A;
  transform: scale(1.1);
}

.contact-details h4 {
  font-size: 20px;
  font-weight: 700;
  color: #fff;
  margin-bottom: 15px;
  font-family: 'Archivo', sans-serif;
}

.contact-details p {
  font-size: 16px;
  line-height: 26px;
  color: #F6EC4F;
  margin-bottom: 10px;
  font-family: 'Open Sans', sans-serif;
  font-weight: 600;
}

.contact-details span {
  font-size: 14px;
  color: #fff;
  font-family: 'Open Sans', sans-serif;
  opacity: 0.8;
}

/* Responsive Design */
@media only screen and (max-width: 991px) {
  .contact-section {
    padding: 80px 0;
  }
}

@media only screen and (max-width: 767px) {
  .contact-section {
    padding: 60px 0;
  }
  .contact-main-title h2 {
    font-size: 36px;
    line-height: 46px;
  }
  
  .contact-description p {
    font-size: 16px;
  }
  
  .contact-info-card {
    padding: 25px 20px;
    margin-bottom: 20px;
  }
  
  .contact-details h4 {
    font-size: 18px;
  }
  
  .contact-details p {
    font-size: 14px;
    line-height: 22px;
  }
  
  .contact-section .pattern-1,
  .contact-section .pattern-2 {
    opacity: 0.05;
  }
}

@media only screen and (max-width: 399px) {
  .contact-section {
    padding: 40px 0;
  }
  
  .contact-main-title h2 {
    font-size: 28px;
    line-height: 38px;
  }
  
  .contact-section-label h4 {
    font-size: 16px;
    letter-spacing: 8px;
  }
  
  .contact-info-card {
    padding: 20px 15px;
    margin-bottom: 15px;
  }
  
  .contact-details h4 {
    font-size: 16px;
  }
  
  .contact-details p {
    font-size: 13px;
    line-height: 20px;
  }
  
  .contact-icon i {
    width: 50px;
    height: 50px;
    line-height: 50px;
    font-size: 30px;
  }
}
</style>
